import React from 'react';
import GatsbyLink from 'gatsby-link';

import { InlineGrid } from '@marvelapp/marvel-ui/grid';
import MarvelLink from '@marvelapp/marvel-ui/link';
import Heading from '@marvelapp/marvel-ui/heading';
import devNavLinks from 'marketing-website/configs/devNavLinks.js';

export function isAbsoluteUrl(url) {
  return url.indexOf('://') > 0 || url.indexOf('//') === 0;
}

export default function HeaderNav() {
  return (
    <nav>
      <InlineGrid size="l">
        {devNavLinks.map(item => {
          const Link = isAbsoluteUrl(item.url) ? MarvelLink : GatsbyLink;
          return (
            <Link to={item.url} url={item.url} data-bypass>
              <MarvelLink url={item.url} data-bypass>
                <Heading tag="h2" color="snow" weight="semibold" size="m">
                  {item.title}
                </Heading>
              </MarvelLink>
            </Link>
          );
        })}
      </InlineGrid>
    </nav>
  );
}



// WEBPACK FOOTER //
// ./src/components/modules/DevHeader/HeaderNav/index.js